module.exports = (__webpack_require__("SEmX"))("CVQP");